import { HeroIcon } from '@components/HeroIcon'
import { ICartItem } from '@dtos/Order'
import { formatMoney } from '@utils/moneyFormatter'
import { useTranslation } from 'react-i18next'
import { Circle, H3, Text, XStack, YStack } from 'tamagui'

interface IOrderBumpProps {
  products?: ICartItem[]
}
export function OrderBump({ products }: IOrderBumpProps) {
  const { t } = useTranslation('OrderDetails')

  if (!products || !products.length) return null

  return (
    <YStack gap="$size.spacing-xxxs">
      <XStack
        bg="$bg-surface-raised"
        paddingVertical="$size.spacing-xxxs"
        paddingHorizontal="$size.spacing-xs"
        alignItems="center"
        gap="$size.spacing-xxxs"
        alignSelf="flex-start"
      >
        <HeroIcon
          icon={['fal', 'cart-shopping']}
          color="$icon-primary"
          size={24}
        />
        <H3 ff="$mulishBold" color="$text-primary" fontSize="$font-size-xxs">
          {t('orderBumpTitle')}
        </H3>
      </XStack>
      {products.map((item) => (
        <XStack
          key={item.product.name}
          alignItems="center"
          gap="$size.spacing-xxxs"
          pl="$size.spacing-xxs"
        >
          <Circle size={5} bg="$icon-primary" />
          <Text
            ff="$mulishRegular"
            color="$text-primary"
            fontSize="$font-size-xxs"
          >
            {item.product.name}
            {item.amount_cents != null && `: ${formatMoney(item.amount_cents)}`}
            {item.item_status === 'refunded' && ` (${t('itemRefunded')})`}
            {item.item_status === 'refund_processing' &&
              ` (${t('itemRefundProcessing')})`}
          </Text>
        </XStack>
      ))}
    </YStack>
  )
}
